import React from 'react';
import { CaseTable, Shimmer } from '../styled';

// Deterministic per-column widths so skeleton rows don't jitter on re-render.
const WIDTHS = ['80%', '55%', '70%', '48%', '65%', '60%', '75%', '50%'];

/**
 * Ghost/skeleton loader that mirrors an outreach table's columns with
 * shimmering placeholder bars. Keeps the real header and column widths so the
 * layout doesn't shift when the data arrives.
 */
const OutreachTableSkeleton = ({ columns, rows = 8, scroll, showSelection = false }) => {
  const skeletonColumns = columns.map((col, ci) => ({
    ...col,
    sorter: false,
    render: () => (
      <Shimmer
        style={{
          width: WIDTHS[ci % WIDTHS.length],
          margin: col.align === 'center' ? '0 auto' : undefined
        }}
      />
    )
  }));

  if (showSelection) {
    skeletonColumns.unshift({
      title: '',
      key: '__sk_sel',
      width: 48,
      render: () => (
        <Shimmer style={{ width: 16, height: 16, borderRadius: 4, margin: '0 auto' }} />
      )
    });
  }

  const data = Array.from({ length: rows }, (_, i) => ({ key: `sk-${i}` }));

  return (
    <CaseTable
      columns={skeletonColumns}
      dataSource={data}
      rowKey="key"
      pagination={false}
      scroll={scroll}
      className="event-management-pagination"
    />
  );
};

export default OutreachTableSkeleton;
